export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ACCEPTED_TYPES = ["image/jpeg", "image/png"];

type ValidationResult =
	| { valid: true; error?: undefined }
	| { valid: false; error: string };

export const validateImageFile = (file: File): ValidationResult => {
	if (!ACCEPTED_TYPES.includes(file.type)) {
		return { valid: false, error: "Only JPEG and PNG files are accepted." };
	}
	if (file.size > MAX_FILE_SIZE) {
		return { valid: false, error: "File size must be less than 10MB." };
	}
	return { valid: true };
};
